<template>
  <UIModalContainer
    footer-classes="flex justify-end"
    :modal-show="modalShow"
    :modal-width="40"
    @handleClick="handleRoutinesDetailClick"
  >
    <template v-slot:header>
      <span v-i18n="schedule">PER_DETAILS</span>
    </template>
    <template v-slot>
      <div
        v-for="(event, idx) in detailsEventsArr"
        :key="event.id"
        class="pb-8"
        :class="{ 'mb-8': idx === detailsEventsArr.length - 1 }"
      >
        <div class="flex flex-col gap-5 sm:flex-row">
          <span class="text-2xl text-label-text font-bold">{{ event.title }}</span>
          <span class="subjectColor"></span>
        </div>
        <div class="flex flex-row mt-5 gap-3 md:gap-7">
          <div class="flex flex-1 gap-5 flex-col">
            <div class="flex items-center">
              <Icon icon="calender" color="primary-green" height="21" width="18" />
              <span class="px-2 md:px-3 text-xs md:text-base text-primary-grey-light">
                {{ event.date || event.day }}
              </span>
            </div>

            <div class="text-xs md:text-base text-label-text font-bold rtl:text-right">
              <span v-i18n="schedule">Subject</span>
              :
              <span class="md:px-3 text-primary-grey-light font-normal">
                {{ event.subject.title || GENERAL_CONSTANTS.NOT_APPLICABLE }}
              </span>
            </div>
            <div class="text-xs md:text-base text-label-text font-bold rtl:text-right">
              <span v-i18n="title">Lesson</span>
              :
              <span v-if="event.lesson" class="md:px-3 text-primary-grey-light font-normal">
                {{ event.lesson.title || GENERAL_CONSTANTS.NOT_APPLICABLE }}
              </span>
            </div>
            <div class="text-xs md:text-base text-label-text font-bold rtl:text-right">
              <span v-i18n="schedule">Lesson Type</span>
              :
              <span v-if="event.lesson" class="md:px-3 text-primary-grey-light font-normal">
                {{ event.lesson.type || GENERAL_CONSTANTS.NOT_APPLICABLE }}
              </span>
            </div>
          </div>
          <div class="flex gap-5 flex-1 flex-col text-left">
            <div class="flex clock-icon whitespace-nowrap items-center">
              <Icon icon="clock" color="primary-purple-600" height="21" width="18" />
              <span class="px-2 md:px-3 text-xs md:text-base text-primary-grey-light">
                {{ localTime(event.startTime) }} - {{ localTime(event.endTime) }}
              </span>
            </div>
            <div class="text-xs md:text-base text-label-text font-bold rtl:text-right">
              <span v-i18n="schedule">Teacher</span>
              :
              <span class="md:px-3 text-primary-grey-light font-normal">
                {{ event.teacher || GENERAL_CONSTANTS.NOT_APPLICABLE }}
              </span>
            </div>
            <div class="text-xs md:text-base text-label-text font-bold rtl:text-right">
              <span v-i18n="schedule">Room</span>
              :
              <span class="md:px-3 text-primary-grey-light font-normal">
                {{ event.room || GENERAL_CONSTANTS.NOT_APPLICABLE }}
              </span>
            </div>
          </div>
        </div>
        <hr v-if="detailsEventsArr.length > 1 && idx < detailsEventsArr.length - 1" class="my-5" />
      </div>
    </template>
  </UIModalContainer>
</template>

<script>
import UIModalContainer from '@components/UiElements/UiModalContainer.vue'
import Icon from '@components/icons/icon.vue'
import timeMixin from '@src/mixins/timeMixin'
import GENERAL_CONSTANTS from '@src/constants/general-constants.js'

export default {
  name: 'RoutinesDetailModal',
  components: {
    UIModalContainer,
    Icon,
  },
  mixins: [timeMixin],
  props: {
    modalShow: {
      type: Boolean,
      default: false,
    },
    detailsEventsArr: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['close'],
  data() {
    return {
      GENERAL_CONSTANTS,
      schedule: 'schedule',
    }
  },
  methods: {
    handleRoutinesDetailClick(eventType) {
      if (eventType === 'close') {
        this.$emit('close')
      }
    },
  },
}
</script>
